/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { RunEventDTO } from "./RunEventDTO";
import { RunEventDTOFromJSON, RunEventDTOFromJSONTyped, RunEventDTOToJSON } from "./RunEventDTO";

/**
 *
 * @export
 * @interface PaginatedRunEventsDTO
 */
export interface PaginatedRunEventsDTO {
  /**
   *
   * @type {Array<RunEventDTO>}
   * @memberof PaginatedRunEventsDTO
   */
  items: Array<RunEventDTO>;
  /**
   * Total events for this run (authoritative for pagination).
   * @type {number}
   * @memberof PaginatedRunEventsDTO
   */
  total: number;
  /**
   *
   * @type {number}
   * @memberof PaginatedRunEventsDTO
   */
  limit: number;
  /**
   *
   * @type {number}
   * @memberof PaginatedRunEventsDTO
   */
  offset: number;
}

/**
 * Check if a given object implements the PaginatedRunEventsDTO interface.
 */
export function instanceOfPaginatedRunEventsDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "items" in value;
  isInstance = isInstance && "total" in value;
  isInstance = isInstance && "limit" in value;
  isInstance = isInstance && "offset" in value;

  return isInstance;
}

export function PaginatedRunEventsDTOFromJSON(json: any): PaginatedRunEventsDTO {
  return PaginatedRunEventsDTOFromJSONTyped(json, false);
}

export function PaginatedRunEventsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedRunEventsDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    items: (json["items"] as Array<any>).map(RunEventDTOFromJSON),
    total: json["total"],
    limit: json["limit"],
    offset: json["offset"]
  };
}

export function PaginatedRunEventsDTOToJSON(value?: PaginatedRunEventsDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    items: (value.items as Array<any>).map(RunEventDTOToJSON),
    total: value.total,
    limit: value.limit,
    offset: value.offset
  };
}
